const messages = {
  title: "Bonus in Euro",
  word: "Bonus",
  description: "bonus worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
};

export default {
  messages,
};
